import { render, staticRenderFns } from "./redir.vue?vue&type=template&id=43172dfc&"
import script from "./redir.vue?vue&type=script&lang=js&"
export * from "./redir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports